/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  LoginGuestParams,
  ProviderChallengePayload,
  RegisterGuestUserAfterCheckInParams,
  RequestExchangeCodeForTokenRequest,
  RequestIdTokenRequest,
  RequestRegisterGuestUserRequest,
  ResponseExternalLoginRegisterCodeFlowResponse,
  ResponseLoginCodeFlowResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ExternalLogin<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags ExternalLogin
   * @name LoginCodeFlowV2
   * @summary Once the user has been authenticated by the external provider we return the user details and JWT token for future requests.
   * @request POST:/api/v2/external-login/login-code-flow
   * @secure
   * @response `200` `ResponseLoginCodeFlowResponse` OK
   */
  loginCodeFlowV2 = (
    data: RequestExchangeCodeForTokenRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseLoginCodeFlowResponse, any>({
      path: `/api/v2/external-login/login-code-flow`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name LoginGuest
   * @summary Processes the signin link supplied to guest users (Auth)
   * @request GET:/api/v2/external-login/login-guest
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  loginGuest = (query: LoginGuestParams, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/external-login/login-guest`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name LoginV2
   * @summary Once the user has been authenticated by the external provider we return the user details and JWT token for future requests.
   * @request POST:/api/v2/external-login/login
   * @secure
   * @response `200` `void` OK
   */
  loginV2 = (data: RequestIdTokenRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/external-login/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name ProviderChallenge
   * @summary Redirects the user to the specified provider's login page.
   * @request POST:/api/v2/external-login/provider-challenge
   * @secure
   * @response `200` `void` OK
   */
  providerChallenge = (
    data: ProviderChallengePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v2/external-login/provider-challenge`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name Register
   * @summary Once the user has been authenticated by the external provider we return the user details and JWT token for future requests.
   * @request POST:/api/v2/external-login/register
   * @secure
   * @response `200` `void` OK
   */
  register = (data: RequestIdTokenRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/external-login/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name RegisterCodeFlowV2
   * @summary Once the user has been authenticated by the external provider we return the user details and JWT token for future requests.
   * @request POST:/api/v2/external-login/register-code-flow
   * @secure
   * @response `200` `ResponseExternalLoginRegisterCodeFlowResponse` OK
   */
  registerCodeFlowV2 = (
    data: RequestExchangeCodeForTokenRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseExternalLoginRegisterCodeFlowResponse, any>({
      path: `/api/v2/external-login/register-code-flow`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags ExternalLogin
   * @name RegisterGuestUserAfterCheckIn
   * @summary Register Guest User (a user that can only sign in with a magic link) and Sends a CheckIn Email
   * @request POST:/api/v2/external-login/register-guest-user-after-check-in
   * @secure
   * @response `200` `void` OK
   */
  registerGuestUserAfterCheckIn = (
    query: RegisterGuestUserAfterCheckInParams,
    data: RequestRegisterGuestUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/api/v2/external-login/register-guest-user-after-check-in`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
